var render = function render(){var _vm=this,_c=_vm._self._c;return (this.value)?_c('el-image',{style:(_vm.Style),attrs:{"src":_vm.Url,"preview-src-list":[_vm.Url],"fit":"cover"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }